// Third Party Library
import { Space } from "antd";

// Constants

import { BtnSubmit } from "../../../../../../components";

// Styles

export const BulkFooter = (props) => {
  const { next, completed } = props;

  return (
    <div>
      <Space>
        <BtnSubmit
          display="inline-block"
          text="Next"
          bgColor="#0E2483"
          color="white"
          padding="9px 18px"
          border="0"
          width="30rem"
          onClick={next}
          showIcon={false}
          disable={completed === false}
        />
      </Space>
    </div>
  );
};

export const SubmitBulk = (props) => {
  const { completed, handleSubmit, onClose } = props;

  return (
    <div>
      <BtnSubmit text="Create" bgColor="#0E2483" color="white" padding="0 20px" onClick={handleSubmit} disable={completed === false}/>
      <BtnSubmit text="Cancel" bgColor="transparent" color="#C8C8C8" border="1px solid #C8C8C8" padding="0 20px" onClick={onClose}/>
    
    </div>
  );
};
